import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  USER_LOADED,
  AUTH_ERROR,
  UPDATE_USER,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  CLEAR_AUTH_MESSAGES,
  UPDATE_USER_COMPLETE,
} from "../types";

const AuthReducer = (state, action) => {
  switch (action.type) {
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user: action.payload,
        user_id: action.payload.user_id,
        userUpdated: false,
      };
    case REGISTER_SUCCESS:
    case LOGIN_SUCCESS:
      localStorage.setItem("token", action.payload.token);
      if (action.payload.refresh_token) {
        localStorage.setItem("refresh_token", action.payload.refresh_token);
      }
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
        loading: false,
        user: action.payload,
        userUpdated: false,
      };
    case UPDATE_USER:
      return {
        ...state,
        user: action.payload,
        user_id: action.payload.user_id,
        loading: false,
        message: "success",
        userUpdated: true,
      };
    case UPDATE_USER_COMPLETE:
      return {
        ...state,
        userUpdated: false,
      };
    case REGISTER_FAIL:
    case AUTH_ERROR:
    case LOGIN_FAIL:
    case LOGOUT:
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        user: null,
        message: action.payload,
      };
    case CLEAR_AUTH_MESSAGES:
      return {
        ...state,
        message: null,
      };
    default:
      return state;
  }
};

export default AuthReducer;